import React from 'react';
import './AllAspects.css';
import GalleryTemplate from "../gallery template/GalleryTemplate";

class AllAspects extends React.Component {

    componentDidMount() {
    }

    render() {
        return (
            <div className={'page'}>
                <div className={'all_aspects'}>
                    <h1 className={'pageTitle'}>Comprehensive Joinery Services for Your Home & Garden</h1>
                    <p className={'pageDescription'}>At Prestige Joinery, we pride ourselves on delivering exceptional craftsmanship across all aspects of joinery. From custom doors and decorative wall panelling to structural elements like dormers and bespoke outdoor lighting, our skilled team is dedicated to creating high-quality, custom solutions that elevate the beauty and functionality of every corner of your home and garden.</p>
                    <GalleryTemplate
                        title={'Rustic Interior Wooden Beams'}
                        description={'Add character and warmth to any room with our custom-crafted wooden false beams, enhancing architectural interest and providing a rustic aesthetic to your interior space.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/All Aspects/IMG-20200623-WA0004.jpg',
                            '/gallery/All Aspects/IMG-20200623-WA0005.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Custom Wooden Dormer Window Structures'}
                        description={'Enhance your roofline and bring more light into your attic space with bespoke wooden dormer window structures, expertly crafted to complement your home\'s exterior.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/All Aspects/2005_0319_175544AA_1.JPG',
                            '/gallery/All Aspects/2005_0319_175600AA_1.JPG',
                            '/gallery/All Aspects/2005_0319_175816AA_1.JPG'
                        ]}/>
                    <GalleryTemplate
                        title={'Bespoke Internal and External Doors'}
                        description={'From elegant interior panel doors to robust exterior entryways, our custom joinery offers a range of high-quality doors, designed and built to perfectly fit your home\'s aesthetic and functional needs.'}
                        width={[4,3]}
                        height={[3,4]}
                        images={[
                            '/gallery/All Aspects/2005_0331_171431AA_1.JPG',
                            '',
                            '/gallery/All Aspects/IMG-20200628-WA0000.JPG',
                            '/gallery/All Aspects/IMG-20210117-WA0001.jpg',
                            '/gallery/All Aspects/IMG-20210117-WA0003_1.jpg',
                            '/gallery/All Aspects/IMG-20210117-WA0004_1.jpg'

                        ]}/>
                    <GalleryTemplate
                        title={'Custom Illuminated Home Bar with Optic Display'}
                        description={'Elevate your entertainment space with a bespoke home bar, featuring a sleek design with integrated front lighting, ample counter space, and a striking wall-mounted optic display for your favourite beverages.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/Garden Rooms/1/20200622_224216_1.jpg'
                        ]}/>
                    <GalleryTemplate
                        title={'Custom Wall Panelling and Integrated Furniture'}
                        description={'Transform your interior with elegant custom wall panelling, offering both decorative appeal and practical integration for features like luxurious window seating or bedroom storage solutions.'}
                        width={[4,3]}
                        height={[3,4]}
                        images={[
                            '/gallery/All Aspects/IMG-20210117-WA0000_1.JPG',
                            '',
                            '/gallery/All Aspects/IMG-20210422-WA0000_1.JPG',
                            '/gallery/All Aspects/IMG-20210422-WA0001.JPG'
                        ]}/>
                    <GalleryTemplate
                        title={'Modern Staircase with Glass Banister'}
                        description={'Elevate your hallway with a striking, contemporary staircase featuring a custom-fitted glass banister. Our expert joinery work ensures a seamless finish that maximises light and space, creating a sophisticated and airy entrance to your home.'}
                        width={[4]}
                        height={[3]}
                        images={[
                            '/gallery/All Aspects/IMG-20260519-WA0004.JPG'
                        ]}/>
                </div>
            </div>
        );
    }
}

export default AllAspects;
